import {
  REQUEST_COMPLETED_STATUS,
  REQUEST_DENIED_STATUS,
  REQUEST_STATUS,
} from '../../../constants/request'

export function getRequestProfileHeaderStatusSelectOption(status, t) {
  const statusItem = REQUEST_STATUS[status.id]

  return {
    ...status,
    backgroundColor: statusItem.backgroundColor,
    label: t(statusItem.text),
    textColor: statusItem.textColor,
    value: status.id,
  }
}

export function getRequestProfileHeaderStatusSelectOptions(options, t) {
  return options.map(option =>
    getRequestProfileHeaderStatusSelectOption(option, t)
  )
}

export function getRequestProfileHeaderStatusSelectValue(status, t) {
  return getRequestProfileHeaderStatusSelectOption(status, t)
}

export function hasRequestProfileUndoneActivities(phases) {
  return phases?.some(phase => phase?.has_undone_activities === true)
}

export function isRequestTerminalStatus(statusId) {
  return (
    statusId === REQUEST_COMPLETED_STATUS || statusId === REQUEST_DENIED_STATUS
  )
}
